// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".K83S57bjmu6v3yQP2Z6Klw\\=\\= {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n", "",{"version":3,"sources":["webpack://src/view-controllers/main.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;AACZ","sourcesContent":[".mainView {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainView": "K83S57bjmu6v3yQP2Z6Klw=="
};
export default ___CSS_LOADER_EXPORT___;
